import React, { useEffect, useState } from "react";
import FileUploader from "../Inputs/FileUploader";
import PrimaryButton from "../Buttons/PrimaryButton";

const Step3 = ({
  register,
  errors,
  watch,
  selectedImmat,
  setSelectedImmat,
  selectedBrand,
  setSelectedBrand,
  brands,
  newBrand,
  setNewBrand,
  handleAddBrand,
  selectedModel,
  setSelectedModel,
  brandModels,
  newModel,
  setNewModel,
  handleAddModel,
  colors,
  newColor,
  setNewColor,
  handleAddColor,
  selectedType,
  handleVehicleTypeChange,
  selectedUsage,
  handleUsageChange,
  getUsagesForType,
  selectedCylindree,
  selectedDuration,
  SelectedCards,
  selectedRealCardCount,
  handleCylindreeChange,
  handleDurationChange,
  handleSelectedCardsChange,
  setSelectedRealCardCount,
  isInSale,
  handleIsInSaleChange,
  selectedFiscalPower,
  handleFiscalPowerChange,
  isDoublePedal,
  setIsDoublePedal,
  setIsInSale,
  setSelectedDuration,
  setSelectedFiscalPower,
  selectedSeats,
  setSelectedSeats,
  selectedRealSeats,
  setSelectedRealSeats,
  selectedTonnage,
  setSelectedTonnage,
  selectedTrailers,
  setSelectedTrailers,
  setSelectedCards,
  otherVehicle,
  setOtherVehicle,
  setValue,
  fileInputRef,
  setDocRef,
  docRef,
}) => {
  const manufactureYear = watch("manufactureYear");
  const firstRegistrationYear = watch("firstRegistrationYear");

  const [manufactureYearOptions, setManufactureYearOptions] = useState([]);
  const [firstRegistrationYearOptions, setFirstRegistrationYearOptions] =
    useState([]);

  // Génère les options d'années pour chaque menu déroulant en fonction des contraintes
  useEffect(() => {
    const startYear = 1950;
    const endYear = 2050;

    // Options pour l'année de fabrication, limitées à une année avant l'année de la première mise en circulation
    setManufactureYearOptions(
      Array.from(
        { length: endYear - startYear + 1 },
        (_, i) => startYear + i
      ).filter(
        (year) => !firstRegistrationYear || year <= firstRegistrationYear
      ) // Modification ici
    );

    // Options pour la première mise en circulation, limitées à l'année de fabrication ou après
    setFirstRegistrationYearOptions(
      Array.from(
        { length: endYear - startYear + 1 },
        (_, i) => startYear + i
      ).filter((year) => !manufactureYear || year >= manufactureYear) // Modification ici
    );
  }, [manufactureYear, firstRegistrationYear]);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {/* Plaque d'immatriculation */}
      <div>
        <label
          htmlFor="immat"
          className="block text-sm font-medium mb-2"
          required
        >
          Plaque d'immatriculation <span className="text-red-500">*</span>
        </label>
        <input
          required
          id="immat"
          value={selectedImmat}
          {...register("immat", {
            required: "Précisez la plaque d'immatriculation s'il vous plaît",
          })}
          className={`py-3 px-4 block w-full border ${
            errors.immat ? "border-red-500" : "border-gray-300"
          } rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500`}
          onChange={(e) => setSelectedImmat(e.target.value)}
          placeholder="1234AB10"
        />
        {errors.immat && <p className="text-red-500">{errors.immat.message}</p>}
      </div>

      {/* Marque du véhicule */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Marque du véhicule <span className="text-red-500">*</span>
        </label>
        <select
          id="brand"
          {...register("brand", { required: "La marque est obligatoire" })}
          className={`py-3 px-4 block w-full border ${
            errors.brand ? "border-red-500" : "border-gray-300"
          } rounded-lg text-sm`}
          value={selectedBrand}
          onChange={(e) => {
            setSelectedBrand(e.target.value);
            setNewBrand("");
          }}
        >
          <option value="" disabled>
            Sélectionner une marque
          </option>
          {brands
            .slice()
            .sort((a, b) => a.localeCompare(b))
            .map((brand, index) => (
              <option key={index} value={brand}>
                {brand}
              </option>
            ))}
        </select>
        <input
          type="text"
          value={newBrand}
          onChange={(e) => setNewBrand(e.target.value)}
          placeholder="Ajouter une nouvelle marque"
          className="py-2 px-4 block w-full border border-gray-300 rounded-lg text-sm"
        />
        <button type="button" onClick={handleAddBrand}>
          Ajouter
        </button>
        {errors.brand && <p className="text-red-500">{errors.brand.message}</p>}
      </div>

      {/* Modèle du véhicule */}
      {selectedBrand && (
        <div>
          <label className="block text-sm font-medium mb-2">Modèle</label>
          <select
            id="model"
            {...register("model", { required: "Le modèle est obligatoire" })}
            className={`py-3 px-4 block w-full border ${
              errors.model ? "border-red-500" : "border-gray-300"
            } rounded-lg text-sm`}
            value={selectedModel}
            onChange={(e) => {
              setSelectedModel(e.target.value);
              setNewModel("");
            }}
          >
            <option value="" disabled>
              Sélectionner un modèle
            </option>
            {brandModels[selectedBrand]
              ?.slice()
              .sort((a, b) => a.localeCompare(b))
              .map((model, index) => (
                <option key={index} value={model}>
                  {model}
                </option>
              ))}
          </select>
          <input
            type="text"
            value={newModel}
            onChange={(e) => setNewModel(e.target.value)}
            placeholder="Ajouter un nouveau modèle"
            className="py-2 px-4 block w-full border border-gray-300 rounded-lg text-sm"
          />
          <button
            className="text-purple-800"
            type="button"
            onClick={handleAddModel}
          >
            Ajouter
          </button>
          {errors.model && (
            <p className="text-red-500">{errors.model.message}</p>
          )}
        </div>
      )}

      {/* Autres champs (N° de châssis, Année de fabrication, Première mise en circulation, Charge utile, Couleur) */}
      <div>
        <label className="block text-sm font-medium mb-2">
          N° de châssis <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="chassisNumber"
          {...register("chassisNumber", {
            required: "Le N° de châssis est obligatoire",
          })}
          className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm"
        />
        {errors.chassisNumber && (
          <p className="text-red-500">{errors.chassisNumber.message}</p>
        )}
      </div>

      <div>
        <label
          htmlFor="manufactureYear"
          className="block text-sm font-medium mb-2"
        >
          Année de fabrication <span className="text-red-500">*</span>
        </label>
        <select
          id="manufactureYear"
          {...register("manufactureYear", {
            required: "L'année de fabrication est obligatoire",
          })}
          className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm"
          defaultValue=""
        >
          <option value="" disabled>
            Choisir une année
          </option>
          {manufactureYearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        {errors.manufactureYear && (
          <p className="text-red-500">{errors.manufactureYear.message}</p>
        )}
      </div>

      <div>
        <label
          htmlFor="firstRegistrationYear"
          className="block text-sm font-medium mb-2"
        >
          Première mise en circulation <span className="text-red-500">*</span>
        </label>
        <select
          id="firstRegistrationYear"
          {...register("firstRegistrationYear", {
            required: "La première mise en circulation est obligatoire",
          })}
          className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm"
          defaultValue=""
        >
          <option value="" disabled>
            Choisir une année <span className="text-red-500">*</span>
          </option>
          {firstRegistrationYearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        {errors.firstRegistrationYear && (
          <p className="text-red-500">{errors.firstRegistrationYear.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">
          Charge utile (t) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          id="payload"
          {...register("payload", {
            required: "La charge utile est obligatoire",
            validate: (value) =>
              /^\d+$/.test(value) || "La charge utile doit être un nombre",
          })}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              e.target.value = value; // Autoriser uniquement les chiffres
            }
          }}
          className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm"
        />
        {errors.payload && (
          <p className="text-red-500">{errors.payload.message}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">
          Couleurs du véhicule <span className="text-red-500">*</span>
        </label>
        <select
          id="carColor"
          {...register("carColor", { required: "La couleur est obligatoire" })}
          value={watch("carColor")}
          className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm"
        >
          <option key={""} value={""} disabled>
            Sélectionner une couleur
          </option>

          {colors.map((color, index) => (
            <option key={index} value={color}>
              {color}
            </option>
          ))}
        </select>

        <input
          type="text"
          value={newColor}
          onChange={(e) => setNewColor(e.target.value)}
          placeholder="Ajouter une nouvelle couleur"
          className="py-2 px-4 block w-full border border-gray-300 rounded-lg text-sm"
        />
        <button
          className="text-purple-800"
          type="button"
          onClick={handleAddColor}
        >
          Ajouter
        </button>
        {errors.carColor && (
          <p className="text-red-500">{errors.carColor.message}</p>
        )}
      </div>
      {/* Chacun des autres champs suit la même structure, incluant les validations et les messages d'erreur */}
      <div>
        <label htmlFor="vehicleType" className="block text-sm font-medium mb-2">
          Type de véhicule <span className="text-red-500">*</span>
        </label>
        <select
          value={selectedType}
          id="vehicleType"
          {...register("vehicleType", {
            required: "Le type de véhicule est obligatoire",
          })}
          onChange={(e) => handleVehicleTypeChange(e.target.value)}
          className={`py-3 px-4 block w-full border ${
            errors.vehicleType ? "border-red-500" : "border-gray-300"
          } rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500`}
        >
          <option value="" disabled>
            Sélectionner un type
          </option>
          <option value="moto">Moto</option>
          <option value="voiture">Voiture/Véhicule de tourisme</option>
          <option value="suv">Jeep (SUV, 4x4)</option>
          <option value="bus">Bus</option>
          <option value="camion">Camion</option>
          <option value="special">Véhicule spécial</option>
        </select>
        {errors.vehicleType && (
          <p className="text-red-500">{errors.vehicleType.message}</p>
        )}
      </div>

      {/* Usage du véhicule (Affiché en fonction du type de véhicule sélectionné) */}
      {selectedType && (
        <div>
          <label htmlFor="usage" className="block text-sm font-medium mb-2">
            Usage du véhicule
          </label>
          <select
            value={selectedUsage}
            id="usage"
            {...register("usage", {
              required: "L'usage du véhicule est obligatoire",
            })}
            onChange={(e) => handleUsageChange(e.target.value)}
            className={`py-3 px-4 block w-full border ${
              errors.usage ? "border-red-500" : "border-gray-300"
            } rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500`}
          >
            <option value="">Sélectionnez l'usage</option>
            {getUsagesForType(selectedType).map((usageOption) => (
              <option key={usageOption.value} value={usageOption.value}>
                {usageOption.label}
              </option>
            ))}
          </select>
          {errors.usage && (
            <p className="text-red-500">{errors.usage.message}</p>
          )}
        </div>
      )}

      {selectedType === "moto" && selectedUsage && (
        <>
          {selectedUsage === "personnel" && (
            <>
              <div>
                <label
                  htmlFor="cylindree"
                  className="block text-sm font-medium mb-2"
                >
                  Cylindrée
                </label>
                <select
                  value={selectedCylindree}
                  id="cylindree"
                  {...register("cylindree", {
                    required: "La cylindrée est obligatoire",
                  })}
                  onChange={(e) => handleCylindreeChange(e.target.value)} // Mettre à jour la cylindrée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une cylindrée</option>
                  <option value="0-50">0 – 50 cm³</option>
                  <option value="51-99">51 – 99 cm³</option>
                  <option value="100-150">100 – 150 cm³</option>
                  <option value="151-350">151 – 350 cm³</option>
                  <option value="350+">{"> 350 cm³"}</option>
                </select>
                {errors.cylindree && (
                  <p className="text-red-500">{errors.cylindree.message}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="duration"
                  className="block text-sm font-medium mb-2"
                >
                  Durée
                </label>
                <select
                  value={selectedDuration}
                  id="duration"
                  {...register("duration", {
                    required: "La durée est obligatoire",
                  })}
                  onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
                {errors.duration && (
                  <p className="text-red-500">{errors.duration.message}</p>
                )}
              </div>
            </>
          )}

          {selectedUsage === "taxi" && (
            <div>
              <label
                htmlFor="duration"
                className="block text-sm font-medium mb-2"
              >
                Durée
              </label>
              <select
                value={selectedDuration}
                id="duration"
                {...register("duration", {
                  required: "La durée est obligatoire",
                })}
                onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
              >
                <option value="">Sélectionnez une durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
              {errors.duration && (
                <p className="text-red-500">{errors.duration.message}</p>
              )}
            </div>
          )}

          {selectedUsage === "commerce" && (
            <>
              <div>
                <label
                  htmlFor="numberOfCards"
                  className="block text-sm font-medium mb-2"
                >
                  Nombre de cartes
                </label>
                <select
                  value={SelectedCards}
                  id="numberOfCards"
                  {...register("numberOfCards", {
                    required: "Le nombre de cartes est obligatoire",
                  })}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  onChange={(e) => {
                    handleSelectedCardsChange(e.target.value);
                  }}
                >
                  <option value="">Sélectionnez un nombre de cartes</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="more">{"> 4"}</option>
                </select>
                {errors.numberOfCards && (
                  <p className="text-red-500">{errors.numberOfCards.message}</p>
                )}
              </div>

              {SelectedCards === "more" && (
                <div>
                  <label
                    htmlFor="cards"
                    className="block text-sm font-medium mb-2"
                  >
                    Précisez le nombre de cartes
                  </label>
                  <input
                    value={selectedRealCardCount}
                    id="cards"
                    {...register("cards", {
                      required: "Précisez le nombre de cartes s'il vous plait",
                    })}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    onChange={(e) => setSelectedRealCardCount(e.target.value)} // Mettre à jour le nombre précis de cartes
                  />
                  {errors.cards && (
                    <p className="text-red-500">{errors.cards.message}</p>
                  )}
                </div>
              )}

              <div>
                <label
                  htmlFor="duration"
                  className="block text-sm font-medium mb-2"
                >
                  Durée
                </label>
                <select
                  value={selectedDuration}
                  id="duration"
                  {...register("duration", {
                    required: "La durée est obligatoire",
                  })}
                  onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
                {errors.duration && (
                  <p className="text-red-500">{errors.duration.message}</p>
                )}
              </div>
            </>
          )}

          {selectedUsage === "ecolage" && (
            <>
              <div>
                <label
                  htmlFor="cylindree"
                  className="block text-sm font-medium mb-2"
                >
                  Cylindrée
                </label>
                <select
                  value={selectedCylindree}
                  id="cylindree"
                  {...register("cylindree", {
                    required: "La cylindrée est obligatoire",
                  })}
                  onChange={(e) => handleCylindreeChange(e.target.value)} // Mettre à jour la cylindrée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une cylindrée</option>
                  <option value="0-50">0 – 50 cm³</option>
                  <option value="51-99">51 – 99 cm³</option>
                  <option value="100-150">100 – 150 cm³</option>
                  <option value="151-350">151 – 350 cm³</option>
                  <option value="350+">{"> 350 cm³"}</option>
                </select>
                {errors.cylindree && (
                  <p className="text-red-500">{errors.cylindree.message}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="duration"
                  className="block text-sm font-medium mb-2"
                >
                  Durée
                </label>
                <select
                  value={selectedDuration}
                  id="duration"
                  {...register("duration", {
                    required: "La durée est obligatoire",
                  })}
                  onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
                {errors.duration && (
                  <p className="text-red-500">{errors.duration.message}</p>
                )}
              </div>
            </>
          )}
        </>
      )}

      {selectedType === "voiture" && selectedUsage && (
        <>
          {selectedUsage === "personnel" && (
            <>
              <div>
                <label
                  htmlFor="isInSale"
                  className="block text-sm font-medium mb-2"
                >
                  En vente/réparation/essai ?
                </label>
                <select
                  value={isInSale}
                  id="isInSale"
                  {...register("isInSale", {
                    required: "Cette question est obligatoire",
                  })}
                  onChange={(e) => handleIsInSaleChange(e.target.value)} // Mettre à jour le statut
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une option</option>
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
                {errors.isInSale && (
                  <p className="text-red-500">{errors.isInSale.message}</p>
                )}
              </div>

              {/* Question selon le statut de vente */}
              {isInSale === "oui" && (
                <>
                  <div>
                    <label
                      htmlFor="numberOfCards"
                      className="block text-sm font-medium mb-2"
                    >
                      Nombre de cartes
                    </label>
                    <select
                      value={SelectedCards}
                      id="numberOfCards"
                      {...register("numberOfCards", {
                        required: "Le nombre de cartes est obligatoire",
                      })}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                      onChange={(e) => {
                        handleSelectedCardsChange(e.target.value);
                      }}
                    >
                      <option value="">Sélectionnez un nombre de cartes</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="more">{"> 4"}</option>
                    </select>
                    {errors.numberOfCards && (
                      <p className="text-red-500">
                        {errors.numberOfCards.message}
                      </p>
                    )}
                  </div>
                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}
                  <div>
                    <label
                      htmlFor="duration"
                      className="block text-sm font-medium mb-2"
                    >
                      Durée
                    </label>
                    <select
                      value={selectedDuration}
                      id="duration"
                      {...register("duration", {
                        required: "La durée est obligatoire",
                      })}
                      onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                      <option value="">Sélectionnez une durée</option>
                      <option value="30">30 jours</option>
                      <option value="90">90 jours</option>
                    </select>
                    {errors.duration && (
                      <p className="text-red-500">{errors.duration.message}</p>
                    )}
                  </div>
                </>
              )}

              {/* Si non en vente */}
              {isInSale === "non" && (
                <>
                  <div>
                    <label
                      htmlFor="fiscalPower"
                      className="block text-sm font-medium mb-2"
                    >
                      Puissance fiscale
                    </label>
                    <select
                      value={selectedFiscalPower}
                      id="fiscalPower"
                      {...register("fiscalPower", {
                        required: "La puissance fiscale est obligatoire",
                      })}
                      onChange={(e) => handleFiscalPowerChange(e.target.value)}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                      <option value="">Sélectionnez une puissance</option>
                      <option value="1-5">1-5 CV</option>
                      <option value="6-9">6-9 CV</option>
                      <option value="10-13">10-13 CV</option>
                      <option value="14-17">14-17 CV</option>
                      <option value="17+">{"> 17 CV"}</option>
                    </select>
                    {errors.fiscalPower && (
                      <p className="text-red-500">
                        {errors.fiscalPower.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <label
                      htmlFor="duration"
                      className="block text-sm font-medium mb-2"
                    >
                      Durée
                    </label>
                    <select
                      value={selectedDuration}
                      id="duration"
                      {...register("duration", {
                        required: "La durée est obligatoire",
                      })}
                      onChange={(e) => handleDurationChange(e.target.value)}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                      <option value="">Sélectionnez une durée</option>
                      <option value="30">30 jours</option>
                      <option value="90">90 jours</option>
                    </select>
                    {errors.duration && (
                      <p className="text-red-500">{errors.duration.message}</p>
                    )}
                  </div>
                </>
              )}
            </>
          )}

          {selectedUsage === "transport_commun" && (
            <>
              <div>
                <label
                  htmlFor="isInSale"
                  className="block text-sm font-medium mb-2"
                >
                  En vente/réparation/essai ?
                </label>
                <select
                  value={isInSale}
                  id="isInSale"
                  {...register("isInSale", {
                    required: "Cette question est obligatoire",
                  })}
                  onChange={(e) => handleIsInSaleChange(e.target.value)}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une option</option>
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
                {errors.isInSale && (
                  <p className="text-red-500">{errors.isInSale.message}</p>
                )}
              </div>

              {/* Questions selon le statut de vente */}
              {isInSale === "oui" && (
                <>
                  <div>
                    <label
                      htmlFor="numberOfCards"
                      className="block text-sm font-medium mb-2"
                    >
                      Nombre de cartes
                    </label>
                    <select
                      value={SelectedCards}
                      id="numberOfCards"
                      {...register("numberOfCards", {
                        required: "Le nombre de cartes est obligatoire",
                      })}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                      onChange={(e) => {
                        handleSelectedCardsChange(e.target.value);
                      }}
                    >
                      <option value="">Sélectionnez un nombre de cartes</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="more">{"> 4"}</option>
                    </select>
                    {errors.numberOfCards && (
                      <p className="text-red-500">
                        {errors.numberOfCards.message}
                      </p>
                    )}
                  </div>
                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}
                  <div>
                    <label
                      htmlFor="duration"
                      className="block text-sm font-medium mb-2"
                    >
                      Durée
                    </label>
                    <select
                      value={selectedDuration}
                      id="duration"
                      {...register("duration", {
                        required: "La durée est obligatoire",
                      })}
                      onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    >
                      <option value="">Sélectionnez une durée</option>
                      <option value="30">30 jours</option>
                      <option value="90">90 jours</option>
                    </select>
                    {errors.duration && (
                      <p className="text-red-500">{errors.duration.message}</p>
                    )}
                  </div>
                </>
              )}

              {/* Si non en vente */}
              {isInSale === "non" && (
                <div>
                  <label
                    htmlFor="duration"
                    className="block text-sm font-medium mb-2"
                  >
                    Durée
                  </label>
                  <select
                    value={selectedDuration}
                    id="duration"
                    {...register("duration", {
                      required: "La durée est obligatoire",
                    })}
                    onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  >
                    <option value="">Sélectionnez une durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                  {errors.duration && (
                    <p className="text-red-500">{errors.duration.message}</p>
                  )}
                </div>
              )}
            </>
          )}

          {selectedUsage === "taxi" && (
            <div>
              <label
                htmlFor="duration"
                className="block text-sm font-medium mb-2"
              >
                Durée
              </label>
              <select
                value={selectedDuration}
                id="duration"
                {...register("duration", {
                  required: "La durée est obligatoire",
                })}
                onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
              >
                <option value="">Sélectionnez une durée</option>
                <option value="90">90 jours</option>
              </select>
              {errors.duration && (
                <p className="text-red-500">{errors.duration.message}</p>
              )}
            </div>
          )}

          {selectedUsage === "ecolage" && (
            <>
              <div>
                <label
                  htmlFor="fiscalPower"
                  className="block text-sm font-medium mb-2"
                >
                  Puissance fiscale
                </label>
                <select
                  value={selectedFiscalPower}
                  id="fiscalPower"
                  {...register("fiscalPower", {
                    required: "La puissance fiscale est obligatoire",
                  })}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  onChange={(e) => {
                    handleFiscalPowerChange(e.target.value);
                  }}
                >
                  <option value="">Sélectionnez une puissance</option>
                  <option value="1-5">1-5 CV</option>
                  <option value="6-9">6-9 CV</option>
                  <option value="10-13">10-13 CV</option>
                  <option value="14-17">14-17 CV</option>
                  <option value="17+">{"> 17 CV"}</option>
                </select>
                {errors.fiscalPower && (
                  <p className="text-red-500">{errors.fiscalPower.message}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="doublePedal"
                  className="block text-sm font-medium mb-2"
                >
                  Double pédale
                </label>
                <select
                  value={isDoublePedal}
                  id="doublePedal"
                  {...register("doublePedal", {
                    required: "Cette question est obligatoire",
                  })}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  onChange={(e) => {
                    setIsDoublePedal(e.target.value);
                  }}
                >
                  <option value="">Sélectionnez une option</option>
                  <option value="oui">Oui</option>
                  <option value="non">Non</option>
                </select>
                {errors.doublePedal && (
                  <p className="text-red-500">{errors.doublePedal.message}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="duration"
                  className="block text-sm font-medium mb-2"
                >
                  Durée
                </label>
                <select
                  value={selectedDuration}
                  id="duration"
                  {...register("duration", {
                    required: "La durée est obligatoire",
                  })}
                  onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
                {errors.duration && (
                  <p className="text-red-500">{errors.duration.message}</p>
                )}
              </div>
            </>
          )}

          {selectedUsage === "location" && (
            <>
              <div>
                <label
                  htmlFor="fiscalPower"
                  className="block text-sm font-medium mb-2"
                >
                  Puissance fiscale
                </label>
                <select
                  value={selectedFiscalPower}
                  id="fiscalPower"
                  {...register("fiscalPower", {
                    required: "La puissance fiscale est obligatoire",
                  })}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une puissance</option>
                  <option value="1-5">1-5 CV</option>
                  <option value="6-9">6-9 CV</option>
                  <option value="10-13">10-13 CV</option>
                  <option value="14-17">14-17 CV</option>
                  <option value="17+">{"> 17 CV"}</option>
                </select>
                {errors.fiscalPower && (
                  <p className="text-red-500">{errors.fiscalPower.message}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="duration"
                  className="block text-sm font-medium mb-2"
                >
                  Durée
                </label>
                <select
                  value={selectedDuration}
                  id="duration"
                  {...register("duration", {
                    required: "La durée est obligatoire",
                  })}
                  onChange={(e) => handleDurationChange(e.target.value)} // Mettre à jour la durée
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                >
                  <option value="">Sélectionnez une durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
                {errors.duration && (
                  <p className="text-red-500">{errors.duration.message}</p>
                )}
              </div>
            </>
          )}
        </>
      )}

      {selectedType === "suv" && selectedUsage && (
        <>
          {selectedUsage === "personnel" && (
            <>
              <select
                value={isInSale}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isInSale", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setIsInSale(e.target.value)}
              >
                <option value="">En vente/réparation/essai ?</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {isInSale === "oui" && (
                <>
                  <select
                    value={SelectedCards}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("numberOfCards", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => handleSelectedCardsChange(e.target.value)}
                  >
                    <option value="">Nombre de cartes</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="more">{"> 4"}</option>
                  </select>

                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}

                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                </>
              )}

              {isInSale === "non" && (
                <>
                  <select
                    value={selectedFiscalPower}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("fiscalPower", {
                      required: "La puissance fiscale est obligatoire",
                    })}
                    onChange={(e) => setSelectedFiscalPower(e.target.value)}
                  >
                    <option value="">Puissance fiscale</option>
                    <option value="1-5">1-5 CV</option>
                    <option value="6-9">6-9 CV</option>
                    <option value="10-13">10-13 CV</option>
                    <option value="14-17">14-17 CV</option>
                    <option value="17+">{"> 17 CV"}</option>
                  </select>

                  <select onChange={(e) => setSelectedDuration(e.target.value)}>
                    <option value="">Durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                </>
              )}
            </>
          )}

          {selectedUsage === "transport_commun" && (
            <>
              <select
                value={isInSale}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isInSale", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setIsInSale(e.target.value)}
              >
                <option value="">En vente/réparation/essai ?</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {isInSale === "oui" && (
                <>
                  <select
                    value={SelectedCards}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("numberOfCards", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => handleSelectedCardsChange(e.target.value)}
                  >
                    <option value="">Nombre de cartes</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="more">{"> 4"}</option>
                  </select>
                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}
                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                </>
              )}

              {isInSale === "non" && (
                <select
                  value={selectedDuration}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  {...register("duration", {
                    required: "Cette question est obligatoire",
                  })}
                  onChange={(e) => setSelectedDuration(e.target.value)}
                >
                  <option value="">Durée</option>
                  <option value="30">30 jours</option>
                  <option value="90">90 jours</option>
                </select>
              )}
            </>
          )}

          {selectedUsage === "taxi" && (
            <select
              value={selectedDuration}
              className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
              {...register("duration", {
                required: "Cette question est obligatoire",
              })}
              onChange={(e) => setSelectedDuration(e.target.value)}
            >
              <option value="">Durée</option>
              <option value="90">90 jours</option>
            </select>
          )}

          {selectedUsage === "ecolage" && (
            <>
              <select
                value={selectedFiscalPower}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("fiscalPower", {
                  required: "La puissance fiscale est obligatoire",
                })}
                onChange={(e) => setSelectedFiscalPower(e.target.value)}
              >
                <option value="">Puissance fiscale</option>
                <option value="1-5">1-5 CV</option>
                <option value="6-9">6-9 CV</option>
                <option value="10-13">10-13 CV</option>
                <option value="14-17">14-17 CV</option>
                <option value="17+">{"> 17 CV"}</option>
              </select>

              <select
                value={isDoublePedal}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isDoublePedal", {
                  required: "La puissance fiscale est obligatoire",
                })}
                onChange={(e) => setIsDoublePedal(e.target.value)}
              >
                <option value="">Double pédale ?</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "location" && (
            <>
              <select
                value={selectedFiscalPower}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("fiscalPower", {
                  required: "La puissance fiscale est obligatoire",
                })}
                onChange={(e) => setSelectedFiscalPower(e.target.value)}
              >
                <option value="">Puissance fiscale</option>
                <option value="1-5">1-5 CV</option>
                <option value="6-9">6-9 CV</option>
                <option value="10-13">10-13 CV</option>
                <option value="14-17">14-17 CV</option>
                <option value="17+">{"> 17 CV"}</option>
              </select>

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}
        </>
      )}

      {selectedType === "bus" && selectedUsage && (
        <>
          {selectedUsage === "transport_commun" && (
            <>
              <select
                value={selectedSeats}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("seats", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedSeats(e.target.value)}
              >
                <option value="">Nombre de places</option>
                <option value="0-15">0 – 15</option>
                <option value="16-30">16 – 30</option>
                <option value="31-50">31 – 50</option>
                <option value=">50">{"> 50"}</option>
              </select>

              {selectedSeats === ">50" && (
                <div>
                  <label
                    htmlFor="seats"
                    className="block text-sm font-medium mb-2"
                  >
                    Précisez le nombre de places
                  </label>
                  <input
                    value={selectedRealSeats}
                    id="realseats"
                    {...register("realseats", {
                      required: "Précisez le nombre de places s'il vous plait",
                    })}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    onChange={(e) => setSelectedRealSeats(e.target.value)} // Mettre à jour le nombre précis de places
                  ></input>
                  {errors.seat && (
                    <p className="text-red-500">{errors.seat.message}</p>
                  )}
                </div>
              )}

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "taxi" && (
            <>
              <select
                value={selectedSeats}
                className="py-3 px-4 block w-full text-dark border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("seats", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedSeats(e.target.value)}
              >
                <option value="">Nombre de places</option>
                <option value="0-15">0 – 15</option>
                <option value="16-30">16 – 30</option>
                <option value="31-50">31 – 50</option>
                <option value=">50">{"> 50"}</option>
              </select>

              {selectedSeats === ">50" && (
                <div>
                  <label
                    htmlFor="seats"
                    className="block text-sm font-bold text-dark mb-2"
                  >
                    Précisez le nombre de places
                  </label>
                  <input
                    value={selectedRealSeats}
                    id="realseats"
                    {...register("realseats", {
                      required: "Précisez le nombre de places s'il vous plait",
                    })}
                    className="py-3 px-4 block w-full text-dark border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    onChange={(e) => setSelectedRealSeats(e.target.value)} // Mettre à jour le nombre précis de places
                  ></input>
                  {errors.seat && (
                    <p className="text-red-500">{errors.seat.message}</p>
                  )}
                </div>
              )}

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full text-dark border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}
        </>
      )}

      {selectedType === "camion" && (
        <>
          {selectedUsage === "marchandises" && (
            <>
              <select
                value={isInSale}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isInSale", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setIsInSale(e.target.value)}
              >
                <option value="">En vente/réparation/essai ?</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {isInSale === "oui" && (
                <>
                  <select
                    value={SelectedCards}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("numberOfCards", {
                      required: "Le nombre de cartes est obligatoire",
                    })}
                    onChange={(e) => {
                      handleSelectedCardsChange(e.target.value);
                    }}
                  >
                    <option value="">Nombre de cartes</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="more">{"> 4"}</option>
                  </select>

                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}

                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                </>
              )}

              {isInSale === "non" && (
                <>
                  <div>
                    <select
                      value={selectedTonnage}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                      {...register("tonnage", {
                        required: "Cette question est obligatoire",
                      })}
                      onChange={(e) => setSelectedTonnage(e.target.value)}
                    >
                      <option value="">Tonnage</option>
                      <option value="0-3.5">0-3.5</option>
                      <option value="3.6-8">3.6-8</option>
                      <option value="9-15">9-15</option>
                      <option value=">15">{"> 15"}</option>
                    </select>
                    {errors.tonnage && (
                      <p className="text-red-500">{errors.tonnage.message}</p>
                    )}
                  </div>

                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="90">90 jours</option>
                  </select>

                  <select
                    value={selectedTrailers}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("trailers", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedTrailers(e.target.value)}
                  >
                    <option value="">Remorque supplémentaire</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </>
              )}
            </>
          )}

          {selectedUsage === "marchandises_r" && (
            <>
              <select
                value={isInSale}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isInSale", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setIsInSale(e.target.value)}
              >
                <option value="">En vente/réparation/essai ?</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              {isInSale === "oui" && (
                <>
                  <select
                    value={SelectedCards}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("numberOfCards", {
                      required: "Le nombre de cartes est obligatoire",
                    })}
                    onChange={(e) => setSelectedCards(e.target.value)}
                  >
                    <option value="">Nombre de cartes</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="more">{"> 4"}</option>
                  </select>
                  {SelectedCards === "more" && (
                    <div>
                      <label
                        htmlFor="cards"
                        className="block text-sm font-medium mb-2"
                      >
                        Précisez le nombre de cartes
                      </label>
                      <input
                        value={selectedRealCardCount}
                        id="cards"
                        {...register("cards", {
                          required:
                            "Précisez le nombre de cartes s'il vous plait",
                        })}
                        className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                        onChange={(e) =>
                          setSelectedRealCardCount(e.target.value)
                        } // Mettre à jour le nombre précis de cartes
                      ></input>
                      {errors.cards && (
                        <p className="text-red-500">{errors.cards.message}</p>
                      )}
                    </div>
                  )}

                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                  </select>
                </>
              )}

              {isInSale === "non" && (
                <>
                  <div>
                    <select
                      value={selectedTonnage}
                      className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                      {...register("tonnage", {
                        required: "Cette question est obligatoire",
                      })}
                      onChange={(e) => setSelectedTonnage(e.target.value)}
                    >
                      <option value="">Tonnage</option>
                      <option value="0-3.5">0-3.5</option>
                      <option value="3.6-8">3.6-8</option>
                      <option value="9-15">9-15</option>
                      <option value=">15">{"> 15"}</option>
                    </select>
                    {errors.tonnage && (
                      <p className="text-red-500">{errors.tonnage.message}</p>
                    )}
                  </div>

                  <select
                    value={selectedDuration}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("duration", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedDuration(e.target.value)}
                  >
                    <option value="">Durée</option>
                    <option value="90">90 jours</option>
                  </select>

                  <select
                    value={selectedTrailers}
                    className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                    {...register("trailers", {
                      required: "Cette question est obligatoire",
                    })}
                    onChange={(e) => setSelectedTrailers(e.target.value)}
                  >
                    <option value="">Remorque supplémentaire</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
                </>
              )}
            </>
          )}

          {selectedUsage === "ecolage" && (
            <>
              <select
                value={isDoublePedal}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("isDoublePedal", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setIsDoublePedal(e.target.value)}
              >
                <option value="">Double pédale</option>
                <option value="oui">Oui</option>
                <option value="non">Non</option>
              </select>

              <div>
                <select
                  value={selectedTonnage}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  {...register("tonnage", {
                    required: "Cette question est obligatoire",
                  })}
                  onChange={(e) => setSelectedTonnage(e.target.value)}
                >
                  <option value="">Tonnage</option>
                  <option value="0-3.5">0-3.5</option>
                  <option value="3.6-8">3.6-8</option>
                  <option value="9-15">9-15</option>
                  <option value=">15">{"> 15"}</option>
                </select>
                {errors.tonnage && (
                  <p className="text-red-500">{errors.tonnage.message}</p>
                )}
              </div>

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "location" && (
            <>
              <div>
                <select
                  value={selectedTonnage}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  {...register("tonnage", {
                    required: "Cette question est obligatoire",
                  })}
                  onChange={(e) => setSelectedTonnage(e.target.value)}
                >
                  <option value="">Tonnage</option>
                  <option value="0-3.5">0-3.5</option>
                  <option value="3.6-8">3.6-8</option>
                  <option value="9-15">9-15</option>
                  <option value=">15">{"> 15"}</option>
                </select>
                {errors.tonnage && (
                  <p className="text-red-500">{errors.tonnage.message}</p>
                )}
              </div>

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="90">90 jours</option>
              </select>

              <select
                value={selectedTrailers}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("trailers", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedTrailers(e.target.value)}
              >
                <option value="">Remorque supplémentaire</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </>
          )}
        </>
      )}

      {selectedType === "special" && selectedUsage && (
        <>
          {selectedUsage === "tracteurs" && (
            <>
              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "excavateurs" && (
            <>
              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "engins" && (
            <>
              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}

          {selectedUsage === "citerne" && (
            <>
              <select
                value={selectedTrailers}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("trailers", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedTrailers(e.target.value)}
              >
                <option value="">Nombre de remorques</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="90">90 jours uniquement</option>
              </select>
            </>
          )}

          {selectedUsage === "autres" && (
            <>
              <div>
                <label
                  htmlFor="otherspecial"
                  className="block text-sm font-medium mb-2"
                >
                  Précisez de quel véhicule il s'agit
                </label>
                <input
                  value={otherVehicle}
                  id="otherspecial"
                  {...register("otherspecial", {
                    required:
                      "Précisez de quel véhicule il s'agit s'il vous plait",
                  })}
                  className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                  onChange={(e) => setOtherVehicle(e.target.value)} // Mettre à jour le nombre précis de cartes
                ></input>
                {errors.otherspecial && (
                  <p className="text-red-500">{errors.otherspecial.message}</p>
                )}
              </div>

              <select
                value={selectedFiscalPower}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("fiscalPower", {
                  required: "La puissance fiscale est obligatoire",
                })}
                onChange={(e) => setSelectedFiscalPower(e.target.value)}
              >
                <option value="">Puissance fiscale</option>
                <option value="1-5">1 – 5 CV</option>
                <option value="6-9">6 – 9 CV</option>
                <option value="10-13">10 – 13 CV</option>
                <option value="14-17">14 – 17 CV</option>
                <option value="17+">{"> 17 CV"}</option>
              </select>

              <select
                value={selectedDuration}
                className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500"
                {...register("duration", {
                  required: "Cette question est obligatoire",
                })}
                onChange={(e) => setSelectedDuration(e.target.value)}
              >
                <option value="">Durée</option>
                <option value="30">30 jours</option>
                <option value="90">90 jours</option>
              </select>
            </>
          )}
        </>
      )}

      <FileUploader
        label="Veuillez attachez la photo du document d'immatriculation"
        fieldName="document"
        setValue={setValue}
        required
        inputRef={fileInputRef}
        setDocRef={setDocRef}
        docRef={docRef}
      />
    </div>
  );
};

export default Step3;
